export const PURCHASE_PAYMENT_INVALIDATED = 'purchase-payment-invalidated';

/** A completed mutation invalidates reads, never supplies payment state itself. */
export function invalidatePurchasePaymentLists(): void {
  window.dispatchEvent(new Event(PURCHASE_PAYMENT_INVALIDATED));
  try {
    localStorage.setItem(PURCHASE_PAYMENT_INVALIDATED, `${Date.now()}:${Math.random()}`);
  } catch {
    // Same-tab invalidation still works when browser storage is unavailable.
  }
}
